
import React from "react";
import { Admin, Resource } from "react-admin";

import dataProvider from "../api/dataProvider";
import AdminDashboard from "./AdminDashboard";
import CustomAdminLayout from "./CustomAdminLayout";

import { UserList, UserCreate, UserEdit } from "./users/Users";
import { UserProfileList, UserProfileEdit } from "./users/UserProfiles";
import { OrganizationList, OrganizationCreate, OrganizationEdit } from "./users/Organizations";
import {
    GovernmentInstitutionList,
    GovernmentInstitutionCreate,
    GovernmentInstitutionEdit
} from "./users/GovernmentInstitutions";
import { TariffPlanList, TariffPlanCreate, TariffPlanEdit } from "./users/TariffPlans";

import { UserActionLogList, UserActionLogShow } from "./statistics/UserActionLogs";
import { PreliminaryRunList, PreliminaryRunShow } from "./statistics/PreliminaryRuns";
import { CompareRunList, CompareRunShow } from "./statistics/CompareRuns";
import { UserProfileAuditLogList, UserProfileAuditLogShow } from "./statistics/UserProfileAuditLogs";

import {
    DownloadFileList,
    DownloadFileCreate,
    DownloadFileEdit,
} from "./downloads/DownloadFiles";

export default function AdminPage() {
    return (
        <Admin
            basename="/adminpanel"
            dataProvider={dataProvider}
            dashboard={AdminDashboard}
            layout={CustomAdminLayout}
        >
            <Resource
                name="users/users"
                list={UserList}
                create={UserCreate}
                edit={UserEdit}
                options={{ label: "Пользователи" }}
            />
            <Resource
                name="users/user-profiles"
                list={UserProfileList}
                edit={UserProfileEdit}
                options={{ label: "Профили польз-лей" }}
            />
            <Resource
                name="users/organizations"
                list={OrganizationList}
                create={OrganizationCreate}
                edit={OrganizationEdit}
                options={{ label: "Организации" }}
            />
            <Resource
                name="users/government-institutions"
                list={GovernmentInstitutionList}
                create={GovernmentInstitutionCreate}
                edit={GovernmentInstitutionEdit}
                options={{ label: "Гос учреждения" }}
            />
            <Resource
                name="users/tariff-plans"
                list={TariffPlanList}
                create={TariffPlanCreate}
                edit={TariffPlanEdit}
                options={{ label: "Тарифы" }}
            />

            <Resource
                name="auditlogs/user-actions"
                list={UserActionLogList}
                show={UserActionLogShow}
                options={{ label: "Действия пользователей" }}
            />
            <Resource
                name="auditlogs/preliminary-runs"
                list={PreliminaryRunList}
                show={PreliminaryRunShow}
                options={{ label: "Предв. анализ" }}
            />
            <Resource
                name="auditlogs/compare-runs"
                list={CompareRunList}
                show={CompareRunShow}
                options={{ label: "Сравнения" }}
            />

            <Resource
                name="auditlogs/profile-audit"
                list={UserProfileAuditLogList}
                show={UserProfileAuditLogShow}
                options={{ label: "Изменения профилей" }}
            />

            <Resource
                name="downloads/files"
                list={DownloadFileList}
                create={DownloadFileCreate}
                edit={DownloadFileEdit}
                options={{ label: "Загрузки" }}
            />
        </Admin>
    );
}